import { render, staticRenderFns } from "./VettoriDetails.vue?vue&type=template&id=ffe4a30c&scoped=true"
import script from "./VettoriDetails.vue?vue&type=script&lang=js"
export * from "./VettoriDetails.vue?vue&type=script&lang=js"
import style0 from "./VettoriDetails.vue?vue&type=style&index=0&id=ffe4a30c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe4a30c",
  null
  
)

export default component.exports